import { render, staticRenderFns } from "./OnlyHeaderLayout.vue?vue&type=template&id=3879d798"
import script from "./OnlyHeaderLayout.vue?vue&type=script&lang=js"
export * from "./OnlyHeaderLayout.vue?vue&type=script&lang=js"
import style0 from "./OnlyHeaderLayout.vue?vue&type=style&index=0&id=3879d798&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports